<template>
  <div class="gradient text-white min-h-screen flex items-center">
    <div class="container mx-auto p-4 flex flex-wrap items-center">
      <div class="w-full md:w-5/12 text-center p-4">
        <img src="../../assets/images/marilyn.svg" alt="Not Found"/>
      </div>
      <div class="w-full md:w-7/12 text-center md:text-left p-4">
        <div class="text-6xl font-medium">404</div>
        <div class="text-xl md:text-3xl font-medium mb-4">
          Ой. Эта страница пропала.
        </div>
        <div class="text-lg mb-8">
          Возможно, вы ошиблись при вводе адреса или страница могла быть перемещена.
        </div>
        <button type="button" @click="toBack()" class="border border-white rounded py-3 px-4 mr-6">Назад</button>
        <button type="button" @click="toHome()" class="border border-white rounded py-3 px-4 ">На главную</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404",
  methods: {
    toHome() {
      this.$router.push('/');
    },
    toBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped>
.gradient {
  background-image: linear-gradient(135deg, #684ca0 35%, #1c4ca0 100%);
}
</style>